import { useState, useRef } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import styles from './PasswordInput.module.css';

// Reusable PasswordInput box with built-in **show/hide** password feature
const PasswordInput = ({ 
  id = "password", 
  value, 
  onChange, 
  autoComplete, 
  error = false, 
  instructions = "", 
  placeHolder = "",
  required = false

}) => {
  const [showPassword, setShowPassword] = useState(false);
  const inputRef = useRef(null);

  // Return focus to the password input after clicking hide/show
  const returnFocus = () => {
    setShowPassword((prev) => !prev);
    if (inputRef.current) {
      const len = inputRef.current.value.length;
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.setSelectionRange(len, len);
      }, 0);
    }
  };

  return (
    <div className = {styles.container}>
      {/* Input Box */}
      <div className = {styles.inputBox}>
        <input
          ref = {inputRef}
          id = {id}
          type = {showPassword ? "text" : "password"}
          className={`${styles.input} ${error ? styles.inputError : ''}`}
          value = {value}
          onChange = {onChange}
          autoComplete = {autoComplete} //{"current-password"} or {"new-password"} for either signup or login
          placeHolder = {placeHolder}
          required = {required}
          aria-invalid = {error ? "true" : "false"}
        />

        {/* Show/Hide Password Button */}
        <button
          type = "button"
          onClick = {returnFocus}
          className = {styles.toggleButton}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </button>
      </div>

      {/* Optional Instructions for Password*/}
      {instructions && value && error && (
        <p className = {styles.instructions}>{instructions}</p>
      )}
    </div>
  );
};

export default PasswordInput;